import './index.css';
import { viewRequests } from '@esg/framework';
import { notification } from 'antd';
import { defaultLocale } from './locales';
import { Router } from './pages';
import { createRoot, Root } from "react-dom/client";
import { AppConfig, setEnv } from '@esg/shared';
import { ModalGlobal, ThemeProvider } from '@esg/ui';
import { env } from './configs';

setEnv(env);

const getRootElement = () => document.getElementById('app')!;
let reactRoot: Root | null = null;

const renderApp = () => {
    const root = getRootElement();

    const app = (
        <AppConfig i18nResources={[defaultLocale]}>
            <ThemeProvider>
                <ModalGlobal />
                <Router />
            </ThemeProvider>
        </AppConfig>
    );

    if (reactRoot == null) {
        reactRoot = createRoot(root);
        reactRoot.render(app);
    } else {
        reactRoot.render(app);
    }
};

export const startApp = () => {
    viewRequests.showNotification.setHandler(async (payload) => {
        if (!payload) {
            throw new Error('Payload is required');
        }

        notification[payload.type]({
            message: payload.title,
            description: payload.message,
            placement: 'bottomLeft',
            icon: payload.type == 'success' && <img width='48' src='/assets/images/success-icon.png' alt='notify' />,
            style: { padding: 10, minHeight: 68, marginRight: 55 },
        });
    });

    renderApp();
};
